module.exports = __webpack_public_path__ + "bullying-f1ee4018043e8003864e1be0ef345417.svg";